const vendorsByGameId = {
    118: 'betradar',
    119: 'betradar',
    749: 'riverslot',
    596: 'riverslot',
    595: 'riverslot',
};

const vendorsByFamilyName = {
    'amatic': 'amaticdigital',
    'apex': 'apex',
    'aristocrats': 'aristocrat',
    'betsoft': 'betsoft',
    'btg': 'btg',
    'coolfire 1': 'coolfire',
    'coolfire 2': 'coolfire',
    'egt': 'egt',
    'gameart': 'gameart',
    'greentube': 'greentube',
    'Greentube': 'greentube',
    'hacksaw': 'hacksawgaming',
    'hacksawgaming': 'hacksawgaming',
    'igrosoft': 'igrosoft',
    'igt': 'igt',
    'merkur': 'merkur',
    'netent': 'netent',
    'pragmatic': 'pragmatic',
    'red tiger': 'redtiger',
    'videoslots': 'mainama',
    'egtdigital': 'egtdigital',
    'amaticdigital': 'amaticdigital',
};

export const vendors = [
    {
        "id": "pragmatic",
        "label": "Pragmatic",
        "safe": true,
        "isClassicMenu": true,
        "classicOrder": 99,
    },
    /*{
        "id": "amatic",
        "label": "Amatic",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },*/
    {
        "id": "amaticdigital",
        "label": "Amatic New",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "apex",
        "label": "Apex",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "aristocrat",
        "label": "Aristocrat",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "betradar",
        "label": "Betradar",
        "safe": false
    },
    {
        "id": "coolfire",
        "label": "COOLFIRE",
        "safe": true,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "egt",
        "label": "EGT",
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "egtdigital",
        "label": "EGT Digital",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "igt",
        "label": "IGT",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "mainama",
        "label": "Mainama",
        "safe": true,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "merkur",
        "label": "Merkur",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "netent",
        "label": "NetEnt",
        "safe": true,
        "isClassicMenu": true,
        "classicOrder": 99,
    },
    {
        "id": "riverslot",
        "label": "Riverslot",
        "demoAllowed": true,
        "safe": false
    },
    {
        "id": "redtiger",
        "label": "Red Tiger",
        "safe": true,
        "isClassicMenu": true,
        "classicOrder": 99,
    },
    {
        "id": "btg",
        "label": "BTG",
        "safe": true,
        "isClassicMenu": true,
        "classicOrder": 99,
    },
    {
        "id": "igrosoft",
        "label": "Igrosoft",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "betsoft",
        "label": "Betsoft",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "gameart",
        "label": "Game Art",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "greentube",
        "label": "Greentube",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "hacksawgaming",
        "label": "Hacksawgaming",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "playson",
        "label": "Playson",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    {
        "id": "habanero",
        "label": "Habanero",
        "safe": false,
        "isClassicMenu": true,
        "demoAllowed": true,
        "classicOrder": 99,
    },
    ...(['asia.games', 'localhost'].some(host => window.location.hostname.includes(host)) ? [{
        "id": "pg",
        "label": "PG Soft",
        "safe": true,
        "isClassicMenu": true,
        "demoAllowed": false,
        "classicOrder": 99,
    }] : []),
];

export const vendorsMap = vendors.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {});

export const checkSafeVendor = (vendorId) => {
    if (vendorId === "other") {
        return false;
    }
    const vendor = vendorsMap[vendorId];
    return vendor && vendor.safe;
}

export const getVendor = (gameId, familyName) => {
    const byGameId = vendorsByGameId[gameId];
    if (byGameId !== undefined) {
        return byGameId;
    }
    if (gameId >= 3500 && gameId <= 3700) {
        return 'pg';
    }
    if (gameId >= 9000 && gameId <= 9107) {
        return 'playson';
    }
    if (gameId >= 9300 && gameId <= 9500) {
        return 'habanero';
    }
    const byFamilyId = vendorsByFamilyName[familyName.toLowerCase()];
    if (byFamilyId !== undefined) {
        return byFamilyId;
    }
    return 'other';
}

export const getLegacyCategory = ({ category, id, family, vendor }) => {
    if (category === "tournaments") {
        return category;
    }
    if (vendor === 'amaticdigital') {
        return 'amatic';
    }
    const byFamilyId = vendorsByFamilyName[family.toLowerCase()];
    if (byFamilyId !== undefined) {
        return byFamilyId;
    }
    return 'other';
}